import { render, staticRenderFns } from "./EventCommentItem.vue?vue&type=template&id=1d003939&scoped=true"
import script from "./EventCommentItem.vue?vue&type=script&lang=js"
export * from "./EventCommentItem.vue?vue&type=script&lang=js"
import style0 from "./EventCommentItem.vue?vue&type=style&index=0&id=1d003939&prod&scoped=true&lang=css"
import style1 from "./EventCommentItem.vue?vue&type=style&index=1&id=1d003939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d003939",
  null
  
)

export default component.exports